import React from 'react';

const ContactCard = () => (
  <div className="admin-screen">
    <h1>Contact Card</h1>
    <p>Manage contact information and business addresses.</p>
  </div>
);

export default ContactCard;
